export const ExpenseModel = {
    expense_id: 0,
    description: "",
    expense_category_id: 0,
    expense_id_recurrent_parent: null,
    amount: 0,
    date: "",
    title : ""
}
